"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.MONTHS_PER_YEAR = exports.DAYS_PER_WEEK = exports.LAST_DAY_OF_MONTH = exports.HOURS_PER_DAY = exports.DEFAULT_TIME_LOCAL = exports.DEFAULT_YEARLY_RETENTION_COUNT = exports.DEFAULT_MONTHLY_THIRD_ROW_RETENTION_COUNT = exports.DEFAULT_THIRD_ROW_RETENTION_COUNT = exports.DEFAULT_SECOND_ROW_RETENTION_COUNT = exports.DEFAULT_FIRST_ROW_RETENTION_COUNT = exports.MONTH_LAST_DAY = exports.RETENTION_COUNT_MIN_NOT_DAILY = exports.RETENTION_COUNT_MIN = exports.RETENTION_COUNT_MAX_YEARLY = exports.RETENTION_COUNT_MAX = void 0;
exports.RETENTION_COUNT_MAX = 9999;
exports.RETENTION_COUNT_MAX_YEARLY = 100;
exports.RETENTION_COUNT_MIN = 1;
exports.RETENTION_COUNT_MIN_NOT_DAILY = 0;
exports.MONTH_LAST_DAY = 32;
exports.DEFAULT_FIRST_ROW_RETENTION_COUNT = 7;
exports.DEFAULT_SECOND_ROW_RETENTION_COUNT = 7;
exports.DEFAULT_THIRD_ROW_RETENTION_COUNT = 21;
exports.DEFAULT_MONTHLY_THIRD_ROW_RETENTION_COUNT = 30;
exports.DEFAULT_YEARLY_RETENTION_COUNT = 1;
exports.DEFAULT_TIME_LOCAL = '12:00 PM';
exports.HOURS_PER_DAY = 24;
exports.LAST_DAY_OF_MONTH = 32;
exports.DAYS_PER_WEEK = 7;
exports.MONTHS_PER_YEAR = 12;
//# sourceMappingURL=constants.js.map